import { render, staticRenderFns } from "./InformeVentasTab.vue?vue&type=template&id=4c979066"
import script from "./InformeVentasTab.vue?vue&type=script&setup=true&lang=js"
export * from "./InformeVentasTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports